import * as TYPES from './types';
export default {
    [TYPES.SET_AGENTS](state, payload) {
        state.originAgents = [...payload];
        state.searchResults = [...payload];
    },
    [TYPES.SET_INFO](state, payload) {
        state.info = Object.assign(state.info, payload);
    },
    [TYPES.SET_SEARCH_AGENTS](state, payload) {
        state.searchResults = [...payload];
    }
};
